import React from "react";
import { Link, useParams } from "react-router-dom";
import Seo from "../components/Seo";
import PageIntro from "../components/qa/PageIntro";
import { getCopy } from "../content/portfolio";

export default function Capabilities() {
  const { locale = "de" } = useParams();
  const copy = getCopy(locale);
  const page = copy.capabilitiesPage;
  const schema = [{ "@context": "https://schema.org", "@type": "ProfilePage", name: page.title, description: page.intro, url: `https://antonrost.de/${locale}/capabilities/`, mainEntity: { "@type": "Person", name: "Anton Rost", jobTitle: "QA Engineer", knowsAbout: page.items.map(item => item[0]) } }];
  return (
    <div className="page-wrapper">
      <Seo locale={locale} metadata={page.seo} path="/capabilities/" schema={schema} />
      <PageIntro titleId="capabilities-title" eyebrow={page.eyebrow} title={page.title} intro={page.intro} />
      <section className="content-wrapper">
        <div className="qa-capability-grid">{page.items.map(([title, description, tools]) => <article className="qa-module-card qa-capability" key={title}><h2 className="h4">{title}</h2><p className="bodycopy">{description}</p><p className="bodycopy qa-capability-tools">{tools}</p></article>)}</div>
      </section>
      <section className="content-wrapper">
        <div className="content-header"><h2 className="h2">{page.workflowTitle}</h2></div>
        <ol className="qa-workflow">{page.workflow.map(([title, description]) => <li key={title}><h3 className="h4">{title}</h3><p className="bodycopy">{description}</p></li>)}</ol>
        <Link className="button-primary bodycopy" to={`/${locale}/projects/`}>{copy.common.allProjects}</Link>
      </section>
    </div>
  );
}
